import { Button, EyeIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

type ViewerLinkButtonProps = {
  onClick: () => void;
};

export const ViewerLinkButton: React.FC<ViewerLinkButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      key="viewer-link-button"
      type="primary"
      icon={<EyeIcon />}
      onClick={onClick}
      data-cy-id="viewer-link-button"
    >
      {t("reporting.machinestatus.view.viewerlink.link_button")}
    </Button>
  );
};
